import { modifyTargetPlanWeekdays, modifyTargetPlans } from '../api/workoutApi';

function getTargetPlanWeekdayId(plan) {
  return plan?.id || plan?.target_plan_weekday_id || null;
}

function planWeekdayUsageCount(weekdayDetails, targetPlanId) {
  if (!weekdayDetails || !targetPlanId) return 0;
  return Object.values(weekdayDetails).reduce((count, day) => {
    const isUsed = (day.plans || []).some(
      (p) => String(p.target_plan_id) === String(targetPlanId)
    );
    return count + (isUsed ? 1 : 0);
  }, 0);
}

/**
 * Remove a weekday's workout assignment so it becomes a rest day.
 * Deletes the target plan when it is not used on any other weekday.
 */
export async function clearWeekdayToRest({
  post,
  eventTypeId,
  planToClear,
  weekdayName = '',
  weekdayDetails = null,
}) {
  const targetPlanWeekdayId = getTargetPlanWeekdayId(planToClear);
  const targetPlanId = planToClear?.target_plan_id;
  if (!targetPlanWeekdayId) {
    return { success: false, message: 'Plan weekday ID not found.' };
  }

  const shouldDeletePlan =
    Boolean(targetPlanId) && planWeekdayUsageCount(weekdayDetails, targetPlanId) <= 1;

  const deleteWeekdayResult = await modifyTargetPlanWeekdays(post, {
    event_type_id: eventTypeId,
    target_plan_weekdays: [{ operation: 'DELETE', id: targetPlanWeekdayId }],
  });

  if (!deleteWeekdayResult.success) {
    return {
      success: false,
      message: deleteWeekdayResult.message || 'Failed to mark day as rest.',
    };
  }

  if (shouldDeletePlan) {
    const deletePlanResult = await modifyTargetPlans(post, {
      event_type_id: eventTypeId,
      target_plans: [{ operation: 'DELETE', id: targetPlanId }],
    });

    if (!deletePlanResult.success) {
      return {
        success: true,
        warning: true,
        message:
          deletePlanResult.message ||
          `${weekdayName || 'Day'} is now a rest day, but cleanup of the unused plan failed.`,
      };
    }
  }

  return {
    success: true,
    message: weekdayName
      ? `${weekdayName} is now a rest day.`
      : 'Day is now a rest day.',
  };
}
